export default __webpack_public_path__ + "static/PAPC-200-745beffe257500d3ab66fc7a3ef54ac7.jpg";